import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inventario-escaso',
  templateUrl: './lista.component.html'
})

export class EscasoComponent{
  tamano = document.body.clientHeight;
  datos = [];
  cargando = false;

}